import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/current-sales-overview';

type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

const getCurrentSalesOverview = async ({ creatorId }: ThisApi['params']): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getCurrentSalesOverview;
